import React, { Component } from 'react';
import main from '../../../../hoc/main';

import TopNav from '../../components/Layout/TopNav';

class VersionHome extends Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
    }

    render() {

        return (
            <div class="swallow_app">
                <TopNav history={this.props.history} />
                
                <h2>Version Home</h2>

            </div>
        );
    }
}

export default main(VersionHome, {
    is_private: true,
});